import React from "react";
import ErrorHorizontal from "../../Error/Horizontal";

const Screen15 = () => {
    return <ErrorHorizontal />;
};

export default Screen15;
